import React from "react";

export const LazyLightBox = React.lazy(() => import("./LazyLightbox"));
